module.exports = __webpack_public_path__ + "static/media/boek_03.4b18084d.png";